module.exports = __webpack_public_path__ + "img/help_indicators.gif";